import router from '@/router'
/* eslint-disable */
import { reactive, getCurrentInstance, watch, toRefs } from '@vue/composition-api'
import AppConstants from '../../appConstants'
import themeConfig from '../../../themeConfig'

export const isObject = obj => typeof obj === 'object' && obj !== null

export const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

const getRandomFromArray = array => array[Math.floor(Math.random() * array.length)]

// ? Light and Dark variant is not included
// prettier-ignore
export const getRandomBsVariant = () => getRandomFromArray(['primary', 'secondary', 'success', 'warning', 'danger', 'info'])

export const isDynamicRouteActive = route => {
  const { route: resolvedRoute } = router.resolve(route)
  return resolvedRoute.path === router.currentRoute.path
}

// Thanks: https://medium.com/better-programming/reactive-vue-routes-with-the-composition-api-18c1abd878d1
export const useRouter = () => {
  const vm = getCurrentInstance().proxy
  const state = reactive({
    route: vm.$route,
  })

  watch(
    () => vm.$route,
    r => {
      state.route = r
    },
  )

  return { ...toRefs(state), router: vm.$router }
}

/**
 * This is just enhancement over Object.extend [Gives deep extend]
 * @param {target} a Object which contains values to be overridden
 * @param {source} b Object which contains values to override
 */
// export const objectExtend = (a, b) => {
//   // Don't touch 'null' or 'undefined' objects.
//   if (a == null || b == null) {
//     return a
//   }

//   Object.keys(b).forEach(key => {
//     if (Object.prototype.toString.call(b[key]) === '[object Object]') {
//       if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
//         /* eslint-disable */
//         a[key] = b[key]
//       } else {
//         /* eslint-disable */
//         a[key] = objectExtend(a[key], b[key])
//       }
//     } else {
//       /* eslint-disable */
//       a[key] = b[key]
//     }
//   })

//   return a
// }


export const getColorFromNews = (news) => {
  // const origins = news.source.filter(item => item.code != AppConstants.PLATFORM_ORIGIN_CODE);
  let color_origin = '';
  for (let index = 0; index < news.source.length; index++) {
    const colorIndex = news.newsContent[0].color_origin.findIndex(item => item.origin == news.source[index]._id);
    if (colorIndex >= 0) {
      color_origin = news.newsContent[0].color_origin[colorIndex];
      break;
    }
  }
  // const color_origin = news.newsContent[0].color_origin.find(item => item.origin == origins[0]._id);
  if (color_origin) {
    return color_origin.color;
  }
  return themeConfig.calendarDefaultColor;
}

export const generateCorrelationId = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    .replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
}

export const getRandomNumberMinMax = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}